import React from 'react';
import { Link, useLocation } from 'react-router-dom';
import { BookOpen, Home, Phone, QrCode } from 'lucide-react';
import { useRestaurant } from '../../context/RestaurantContext';

const MobileBottomNav: React.FC = () => {
  const location = useLocation();
  const { settings } = useRestaurant();

  if (location.pathname.startsWith('/item/')) {
    return null;
  }

  const navItems = [
    { path: '/', label: 'Home', icon: Home },
    { path: '/menu', label: 'Menu', icon: BookOpen },
    { path: '/qr-code', label: 'QR', icon: QrCode },
    { path: '/contact', label: 'Contact', icon: Phone },
  ];

  const isActive = (path: string) => {
    if (path === '/') return location.pathname === '/';
    return location.pathname.startsWith(path);
  };

  return (
    <nav className="fixed bottom-0 left-0 right-0 z-50 border-t border-amber-500/15 bg-[#140908]/90 backdrop-blur-xl md:hidden">
      <div className="mx-auto flex h-16 max-w-md items-center justify-around">
        {navItems.map(({ path, label, icon: Icon }) => (
          <Link
            key={path}
            to={path}
            className={`flex h-full flex-1 flex-col items-center justify-center transition-all duration-200 ${
              isActive(path) ? '' : 'text-white/50 hover:text-white'
            }`}
            style={isActive(path) ? { color: settings.brandColors.primary } : undefined}
          >
            <Icon className="mb-1 h-5 w-5" />
            <span className="text-[10px] font-medium">{label}</span>
          </Link>
        ))}
      </div>
    </nav>
  );
};

export default MobileBottomNav;
